import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";
import { useFormFlowStepSync } from "./FormFlowStepSyncContext";

export const FormFlowFormikSync = () => {
  const stepSync = useFormFlowStepSync();
  const { values } = useFormikContext<Record<string, unknown>>();
  const hasMountedRef = useRef(false);
  const syncCurrentStepDataRef = useRef(stepSync?.syncCurrentStepData);

  syncCurrentStepDataRef.current = stepSync?.syncCurrentStepData;

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }

    syncCurrentStepDataRef.current?.(values);
  }, [values]);

  return null;
};
